// The official Vaarta marks: `full` is the wordmark, `symbol` the two-blob mark.
// Both are the real brand PNGs copied from the platform frontend.
import { cn } from '../../lib/cn';
import vaartaLogoUrl from '../../assets/vaarta-logo.png';
import vaartaSymbolUrl from '../../assets/vaarta-symbol.png';

type BrandLogoProps = {
  alt?: string;
  className?: string;
  variant?: 'full' | 'symbol';
};

export function BrandLogo({ alt = 'Vaarta', className, variant = 'full' }: BrandLogoProps) {
  const symbol = variant === 'symbol';
  return (
    <img
      src={symbol ? vaartaSymbolUrl : vaartaLogoUrl}
      alt={alt}
      decoding="async"
      loading="eager"
      className={cn(
        /*
         * `object-contain` and `self-start` are load-bearing, not defensive
         * polish: an <img> with `width: auto` is a flex item whose cross size is
         * auto, so as a direct child of a `flex-col` it STRETCHES to the
         * column's width. On the sign-in page that smeared the wordmark 643px
         * across the panel at 24px tall. `self-start` stops the stretch;
         * `object-contain` keeps the artwork undistorted if anything else ever
         * forces a box on it.
         */
        'w-auto self-start object-contain',
        symbol ? 'h-6' : 'h-5',
        /*
         * The wordmark is near-black type with two coloured accents, so on a dark
         * surface it simply disappears. Rendered as a white silhouette there —
         * the standard treatment for a dark mark on a dark ground, and the only
         * one that keeps it legible without recolouring the accents into
         * something that is not the brand. The symbol is full-colour artwork and
         * reads correctly on both.
         */
        !symbol && 'dark:brightness-0 dark:invert',
        className,
      )}
    />
  );
}

export default BrandLogo;
